import { Routes } from '@angular/router';
import { ComponentTest } from './ui/components/component-test.component';
import { authGuard } from './core/guards/auth.guard';
import { loggedGuard } from './core/guards/logged.guard';

export const routes: Routes = [

  {
    path: 'auth',
    loadChildren: () => import('./ui/pages/auth/auth.routes').then(m => m.AUTH_ROUTES),
    canActivateChild: [loggedGuard]
  },
  { path: 'component-test', component: ComponentTest },
  { path: 'home', loadChildren: () => import('./ui/pages/home/home.routes').then(m => m.HOME_ROUTES),
   canActivateChild: [authGuard]
   },
  {
    path: 'public/forms',
    loadComponent: () =>
      import('./ui/pages/public-form/public-form.component').then(
        (m) => m.PublicFormComponent
      ),
  },
  {
    path: 'form/:tenantId/:productId',
    loadComponent: () =>
      import('./ui/pages/public-form/public-form.component').then(
        (m) => m.PublicFormComponent
      ),
  },
  {
    path: '**',
    redirectTo: 'auth',
    pathMatch: 'prefix'
  },
];
